/* eslint-disable react-hooks/exhaustive-deps */
import Breadcrumbs from '@components/breadcrumbs';
import { isUserLoggedIn } from '@src/utility/Utils';
import '@styles/react/libs/flatpickr/flatpickr.scss';
import '@styles/react/pages/page-account-settings.scss';
import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row, TabContent, TabPane } from 'reactstrap';
import { useBrand } from '@src/utility/hooks/useBrand';

import { GeneralTabs } from './GeneralTabContent';
import { PasswordTabContent } from './PasswordTabContent';
import { Tabs } from './Tabs';
import { SendDocumentary } from '../SendDocumentary';
import ActionHistory from './ActionHistory';

const Profile: React.FC = () => {
  const params = new URLSearchParams(window.location.search);

  const [activeTab, setActiveTab] = useState('1');
  const [data, setData] = useState(null);

  const { nameTab } = useBrand();

  const toggleTab = (tab: string) => {
    setActiveTab(tab);
  };

  useEffect(() => {
    document.title = `Perfil | ${nameTab}`;
    if (isUserLoggedIn() !== null) {
      setData(JSON.parse(localStorage.getItem('userData') as string));
    }
  }, [nameTab]);

  useEffect(() => {
    if (params.get('tab') !== null) {
      setActiveTab(params.get('tab') ?? '1');
    }
  }, []);

  return (
    <>
      <Breadcrumbs
        breadCrumbTitle="Configurações da conta"
        breadCrumbParent="Menu"
        breadCrumbActive="Configurações da conta"
      />
      {data !== null ? (
        <Row>
          <Col className="mb-2 mb-md-0" md="3">
            <Tabs activeTab={activeTab} toggleTab={toggleTab} />
          </Col>
          <Col md="9">
            <Card>
              <CardBody>
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="1">
                    <GeneralTabs data={data} />
                  </TabPane>
                  <TabPane tabId="2">
                    <PasswordTabContent />
                  </TabPane>
                  <TabPane tabId="3">
                    <SendDocumentary />
                  </TabPane>
                  <TabPane tabId="5">
                    <ActionHistory />
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      ) : null}
    </>
  );
};

export default Profile;
